"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactProfileEnum = void 0;
var ContactProfileEnum;
(function (ContactProfileEnum) {
    ContactProfileEnum["NO_EMAIL"] = "no email";
    ContactProfileEnum["API"] = "api";
    ContactProfileEnum["COMPANY_OWNER"] = "company owner";
    ContactProfileEnum["MASTER_GENERIC"] = "master generic";
    ContactProfileEnum["CHILD_GENERIC"] = "child generic";
    ContactProfileEnum["INSTALLER"] = "installer";
    ContactProfileEnum["ADMIN"] = "admin";
    ContactProfileEnum["DISPOSITION"] = "disposition";
    ContactProfileEnum["PROJECT_MANAGER_DEFAULT"] = "project manager default";
    ContactProfileEnum["PROJECT_MANAGER_GENERIC"] = "project manager generic";
    ContactProfileEnum["WEBFORM_EDITOR"] = "webform editor";
    ContactProfileEnum["ACTIVITY_EMAIL_RECIPIENT"] = "activity email recipient";
    ContactProfileEnum["ACCOUNTING"] = "accounting";
    ContactProfileEnum["REPORTING"] = "reporting";
    ContactProfileEnum["CHARGEPOINT_MANAGER"] = "chargepoint-manager";
    ContactProfileEnum["GID"] = "GID";
    ContactProfileEnum["FINANCE"] = "Finance";
    ContactProfileEnum["FINANCE_POWER_USER"] = "Finance PowerUser";
    ContactProfileEnum["PRODUCT"] = "Product";
    ContactProfileEnum["PRODUCT_POWER_USER"] = "Product Power User";
    ContactProfileEnum["EXTERNAL_DATA_MAINTAINER"] = "External Data Maintainer";
    ContactProfileEnum["PARTNER_MANAGEMENT"] = "Partner MGT";
    ContactProfileEnum["PARTNER_ONBOARDING"] = "Partner Onboarding";
    ContactProfileEnum["CUSTOMER_MANAGEMENT"] = "Customer MGT";
    ContactProfileEnum["BRAND_MANAGEMENT"] = "Brand MGT";
    ContactProfileEnum["EXTERNAL_TAX_OFFICE"] = "External-Tax-Office";
    ContactProfileEnum["LOGIN_AS_USER"] = "Login As User";
    ContactProfileEnum["TECHNICAL_SUPPORT"] = "Technical Support";
})(ContactProfileEnum = exports.ContactProfileEnum || (exports.ContactProfileEnum = {}));
//# sourceMappingURL=contact-profile-enum.js.map